export const influencerPageClickTypes = {
  CTA_STRIP_CARD_BUTTON_CLICK: "cta_strip_card_button_click",
  CAROUSEL_TILES_ENGAGEMENT_VIDEO_CLICK: "carousel_tiles_engagement_video_click",
  CAROUSEL_TILES_ENGAGEMENT_LINK_CLICK: "carousel_tiles_engagement_link_click",
  CAROUSEL_TILES_ENGAGEMENT_CARD_CLICK: "carousel_tiles_engagement_card_click",
  CAROUSEL_TILES_CARD_CLICK: "carousel_tiles_card_click",
  CAROUSEL_TILES_BUTTON_CLICK: "carousel_tiles_button_click",
  CAROUSEL_TILES_CAROUSEL: "carousel_tiles_carousel",
  VIDEO_CARD_BUTTON_CLICK: "video_card_button_click",
  INFLUENCER_SEARCH_BUTTON_CLICK: "influencer_search_button_click",
  SEARCH_BAR_BUTTON_CLICK: "search_bar_button_click",
  SEARCH_BAR_ICON_CLICK: "search_bar_icon_click",
  SEARCH_BAR_TAB_CLICK: "search_bar_tab_click",
  BOTTOM_NAVIGATION_ICON_CLICK: "bottom_navigation_icon_click",
  BOTTOM_NAVIGATION_BACK_CLICK: "bottom_navigation_back_click",
  FOOTER_ICON_CLICK: "footer_icon_click",
  FOOTER_LINK_CLICK: "footer_link_click",
  FOOTER_DOWNLOAD_ICON: "footer_download_icon",
  TOP_NAVIGATION_BAR_HEADER_ICON_CLICK: "top_navigation_bar_header_icon_click",
  SCREEN_BACK_CLICK: "screen_back_click",
} as const;

export const influencerPageComponents = {
  INFLUENCER_PROFILE: "influencer_profile",
  CAROUSEL_TILES_ENGAGEMENT: "carousel_tiles_engagement",
  CAROUSEL_TILES: "carousel_tiles",
  VIDEO_CARD: "video_card",
  INFLUENCER_SEARCH: "influencer_search",
  SEARCH_BAR: "search_bar",
  BOTTOM_NAVIGATION: "bottom_navigation",
  FOOTER: "footer",
  TOP_NAVIGATION_BAR_HEADER: "top_navigation_bar_header",
  SCREEN_BACK: "screen_back",
} as const;

export const influencerPageDLComponents = {
  FEATURED_CREATOR_COMPONENT: "FeaturedCreatorComponent",
  INFLUENCER_PROFILE: "influencer_profile",
} as const;

export const influencerPageDLElements = {
  USER_LIST_ITEM: "USER_LIST_ITEM",
} as const;

export const influencerPageEventNames = {
  SOCIAL_COMMERCE_CLICKED: "SOCIAL_COMMERCE_CLICKED",
  SOCIAL_COMMERCE_VIEWED: "SOCIAL_COMMERCE_VIEWED",
} as const;

export const influencerPageEventTypes = {
  CLICK: "click",
} as const;

export const influencerPageJourneyNames = {
  INFLUENCERS: "INFLUENCERS",
} as const;

export const influencerPageNames = {
  INFLUENCER_PAGE: "influencer-page",
} as const;

export const influencerPagePropertyTypes = {
  CLP: "clp",
} as const;

export const influencerPageReferenceIds = {
  INFLUENCER_PROFILE: "influencer_profile",
  CAROUSEL_TILES_ENGAGEMENT: "carousel_tiles_engagement",
  RECENT_LIVE_VIDEOS: "recent_live_vidoes",
  FEATURED_VIDEOS: "featured_videos",
  UPCOMING_LIVE: "upcoming_live",
  INFLUENCER_SEARCH: "influencer_search",
  SEARCH_BAR: "search_bar",
  BOTTOM_NAVIGATION: "bottom_navigation",
  FOOTER: "footer",
  TOP_NAVIGATION_BAR_HEADER: "top_navigation_bar_header",
  SCREEN_BACK: "screen_back",
} as const;

export const influencerPageSectionTitles = {
  FEATURED_CREATORS: "Featured Creators",
} as const;
